import {defineMessages} from 'react-intl'
import {GuestType} from 'types/Hotel'

import {IconName} from '@vio/atlas/Icon'

import {MeritBadge} from '../../../utils/hotelBadges'

export const HotelBadgeMessages = defineMessages({
  business: {
    id: 'tripTypeBadge.businessFriendly',
    defaultMessage: 'Business friendly'
  },
  solo: {
    id: 'tripTypeBadge.soloFriendly',
    defaultMessage: 'Solo friendly'
  },
  groups: {
    id: 'tripTypeBadge.bestForGroups',
    defaultMessage: 'Best for groups'
  },
  couples: {
    id: 'tripTypeBadge.greatForCouples',
    defaultMessage: 'Great for couples'
  },
  families: {
    id: 'tripTypeBadge.familyFriendly',
    defaultMessage: 'Family friendly'
  },
  top_booked: {
    id: 'meritTypeBadge.topBooked',
    defaultMessage: 'Top booked'
  }
})

export const HotelBadgeTooltipMessages = defineMessages({
  business: {
    id: 'tripTypeTooltip.businessFriendly',
    defaultMessage: 'Frequently booked by business travelers.'
  },
  solo: {
    id: 'tripTypeTooltip.soloFriendly',
    defaultMessage: 'Frequently booked by solo travelers.'
  },
  groups: {
    id: 'tripTypeTooltip.bestForGroups',
    defaultMessage: 'Frequently booked by groups.'
  },
  couples: {
    id: 'tripTypeTooltip.greatForCouples',
    defaultMessage: 'Frequently booked by couples.'
  },
  families: {
    id: 'tripTypeTooltip.familyFriendly',
    defaultMessage: 'Frequently booked by families.'
  },
  top_booked: {
    id: 'meritTypeTooltip.topBooked',
    defaultMessage:
      '{rating, plural, one {Among the most booked #-star hotels in {city}.} other {Among the most booked #-star hotels in {city}.}}'
  }
})

export const BadgeIconMap: Record<keyof GuestType | MeritBadge, IconName> = {
  business: 'Briefcase',
  solo: 'Person',
  groups: 'People',
  couples: 'Heart',
  families: 'Pram',
  top_booked: 'Trophy'
}
